import Vue from 'vue'
import Vuex from 'vuex'
import {loadMulpay} from "@mul-pay/mptoken-js";
import axios from "axios";

Vue.use(Vuex)

/**
 * @typedef {Object} MpTokenObject
 * @property {string} token - MPクレカトークン
 * @property {string} toBeExpiredAt - トークン有効期限（ISO 8601）
 * @property {string} maskedCardNo - マスク済みカード番号（例: "************1234"）
 * @property {string} isSecurityCodeSet - セキュリティコード設定有無 ("true"/"false")
 */

/**
 * @typedef {Object} MpTokenResult
 * @property {string} resultCode - 処理結果コード（"000"で成功、それ以外はエラー）
 * @property {MpTokenObject} [tokenObject] - 成功時のトークン情報
 */


/**
 * @typedef {Object} MpTokenResult
 * @property {string} resultCode - 処理結果コード（"000"で成功、それ以外はエラー）
 * @property {MpTokenObject} [tokenObject] - 成功時のトークン情報
 */



const apiKey = "OTI0YWU0MGM0M2ZjMmY5M2QwNWQ5YWM0NjRjYzlkYTZjN2NiOGY2NGQ1MmZkNzk0ZWIwMTUzOTY2Yjk4ZDk3MHRzaG9wMDAwMjY5MzE="
const publicKey = "MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEA/NQ9FNSjqlYAIRa6VuE2BPvfSPZgdttgG444Tr77gCM+14QfhTs4/yXK54yZQifhAmnyknKeGgT1+LYe3NajwbBqoVXStIAcYnqp8zl71NgXg3r97EwGK/wf5ZhJnp6sGRc7t7KlrQMcKrek4RtLeDQv8koG4Sc1SVnxD/+VUFlWSLx78BgkF77BEdh4nbByjgwNOPqCs6v5Pzo/2nUZK8KZBcv2ybkuR7xsN3s9yKKCi8OKcpMu46ZKcfigdnQgRDu9yQKo9pNuBMZ1jd9fQQwCI8QgmrUZaY6LG428/lWxQec8Pu9i4ChPIm5uqqFpr+FLNmQhslGXq/ReuPtrHOS75q11U0ezjRlATpC8VYG+TT0RWJ+SkW1vKpgDB4CGru5/lb9ZrEVNCkejjTYcxmjxl5JmbseKZ6FVnATfcz1wdBgvgcpRrF8+RdOoLUCqIXOh9wMZYeNVWr8shwvDVz9fDBaYoKtxhXVJNRBjS91ktemMsCPmMd6TB4szaUdBAgMBAAE="
const productionMode = false

export default {
  namespaced: true,
  state: {
    mpToken: null,
    ready: false,
    /** @type {import('@mul-pay/mptoken-js').MultiPayment|null} */
    mulpay: null,
    test: "This is store data"
  },
  getters: {
    cardInputStyle() {
      return {
        base: {
          fontFamily: "'Noto Sans Japanese', sans-serif",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.30)",
          },
          caretColor: "#198FCC",
          lineHeight: "28px",
        },
        invalid: {
          color: "#9e2146",
        },
      }
    },
    expiryInputStyle() {
      return {
        base: {
          fontFamily: "'Noto Sans Japanese', sans-serif",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.30)",
          },
          caretColor: "#198FCC",
          lineHeight: "28px",
        },
        invalid: {
          color: "#9e2146",
        },
      }
    },
    cvcInputStyle() {
      return {
        base: {
          fontFamily: "'Noto Sans Japanese', sans-serif",
          "::placeholder": {
            color: "rgba(0, 0, 0, 0.30)",
          },
          caretColor: "#198FCC",
          lineHeight: "28px",
        },
        invalid: {
          color: "#9e2146",
        },
      }
    }
  },
  mutations: {
    setReady(state, value) {
      state.ready = value;
    },
    setupMulpay(state, value) {
      state.mulpay = value;
    }
  },
  actions: {
    async initPayment({commit, dispatch, state}) {
      console.log('initPayment')
      if (state.ready) return;
      await dispatch('createMulpay')
      commit('setReady')
    },
    async createMulpay({commit}) {
      const mulpay = await loadMulpay(apiKey, publicKey, null, true, productionMode);
      commit('setupMulpay', mulpay);
      return mulpay;
    },
    async requestMpToken({commit, dispatch, state}, {cardNo, expiry, securityCode}) {
      state.mulpay.getTokenThroughIframe()
    },
    async submitWithCredit({commit, dispatch, state}, {token, ticket}) {
      console.log('submitWithCredit', token, ticket)
      let {data} = await axios.post("/api/status/gmo/submit", {
        ticketId: ticket.id,
        paymentMethod: "card",
        token: token
      })
      console.log('submitWithCredit', token, ticket, data)
      if (data.redirectUrl) {
        location.href = data.redirectUrl
      }
    },
    async submitWithCreditLink({commit, dispatch, state}, ticket) {
      console.log('submitWithCreditLink', ticket)
      let {data} = await axios.post("/api/status/gmo/submit", {
        ticketId: ticket.id,
        paymentMethod: "card"
      })
      if (data.redirectUrl) {
        location.href = data.redirectUrl
      }
    },
    async submitWithCVS({commit, dispatch, state}, ticket) {
      console.log('submitWithCVS', ticket)
      let {data} = await axios.post("/api/status/gmo/submit", {
        ticketId: ticket.id,
        paymentMethod: "webcvs"
      })
      if (data.redirectUrl) {
        location.href = data.redirectUrl
      }
    },
    async getLink({commit}) {
      let {data} = await axios.get("/api/status/gmo/getlink")
      if (data.redirectUrl) {
        location.href = data.redirectUrl
      }
    }
  }
}
